import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { RoleApiService } from "./domains/roles/services/role-api.service";
import { PermissionGroupApiService } from "./domains/permission-groups/services/permission-group-api.service";

export const authenticationRoutes: Routes = [
  {
    path: "permission-groups",
    loadChildren: () => import("./domains/permission-groups/permission-groups.routes").then(r => r.permissionGroupsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.PERMISSION_GROUP.VIEW },
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.AUTHENTICATION.PERMISSION_GROUPS, TRANSLATION_PATHS.AUTHENTICATION.SHARED]) },
    providers: [PermissionGroupApiService],
  },
  {
    path: "roles",
    loadChildren: () => import("./domains/roles/roles.routes").then(r => r.rolesRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.ROLE.VIEW },
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.AUTHENTICATION.ROLES,
        TRANSLATION_PATHS.SETTINGS.SYSTEM_SETTINGS,
        TRANSLATION_PATHS.AUTHENTICATION.SHARED,
      ]),
    },
    providers: [RoleApiService],
  },
  {
    path: "users",
    resolve: {
      translation: loadTranslationResolver([
        TRANSLATION_PATHS.ROOT,
        TRANSLATION_PATHS.AUTHENTICATION.SHARED,
        TRANSLATION_PATHS.AUTH,
        TRANSLATION_PATHS.USERS.SHARED,
        TRANSLATION_PATHS.AUTHENTICATION.ROLES,
        TRANSLATION_PATHS.AUTHENTICATION.USERS,
        TRANSLATION_PATHS.SETTINGS.SYSTEM_SETTINGS,
        TRANSLATION_PATHS.AUTHENTICATION.AUDIT_LOGS,
      ]),
    },
    loadChildren: () => import("./domains/users-with-credentials/users-with-credentials.routes").then(r => r.usersRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.USER.VIEW },
  },
  {
    path: "audit-logs",
    loadChildren: () => import("./domains/audit-logs/audit-logs.routes").then(r => r.auditLogsRoutes),
    canActivate: [AuthGuard],
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.AUDIT_LOG.VIEW },
    resolve: {
      translation: loadTranslationResolver([TRANSLATION_PATHS.AUTHENTICATION.AUDIT_LOGS, TRANSLATION_PATHS.AUTHENTICATION.SHARED]),
    },
  },
];
